

import RawApiCall from './rawApiCall';
import BuildUrl from './buildUrl';
import { LogCategory, log } from './logger';

var Page = require('../constants/page');

// note: node-fetch does not work correctly when doing a POST from the client side.
//       for now, doing everything using GET
export default class ClientCall {

    static async _logErrorImpl(siteUrl, session, error, userId, email) {
        log(LogCategory.clientCall,"client logError " + session + "/" + error);

        var url = new BuildUrl(siteUrl + "call")
            .add("action", "error")
            .add("session", session)
            .add("userId", userId)
            .add("email", email)
            .add("error", error);

        var req = {
            url: url.get(),
            method: 'GET',
        };
        let result = await RawApiCall.apiCall(req);
        let ok = result.status == 200;
        if ( !ok )
            log(LogCategory.error,"client logE error=" + result.body);
        // on error - the result.json is the error details
        return ok ? { page: 0,  errors: [], success: true } : result.json;
    }

    static async startTrial(siteUrl, session, productId, fingerprint, enableTrialAbuseCheck, userId, email) {
        log(LogCategory.clientCall,"client startTrial " + session + "/" + productId);

        var url = new BuildUrl(siteUrl + "call")
            .add("action", "startTrial")
            .add("session", session)
            .add("userId", userId)
            .add("email", email)
            .add("id", productId)
            .add("fingerprint", fingerprint)
            .add("enableTrialAbuseCheck", enableTrialAbuseCheck)
            ;
        var req = {
            url: url.get(),
            method: 'GET',
        };
        let result = await RawApiCall.apiCall(req);
        let ok = result.status == 200;
        if ( !ok )
            log(LogCategory.error,"client startTrial error=" + result.body);
        // on error - the result.json is the error details
        return ok ? { page: 0,  errors: [], success: true } : result.json;
    }

    static async netellerVerify(siteUrl, session, accountId, userId, email) {
        log(LogCategory.clientCall,"client netellerVerify " + session );

        var url = new BuildUrl(siteUrl + "call")
            .add("action", "netellerVerify")
            .add("session", session)
            .add("userId", userId)
            .add("email", email)
            .add("accountId", accountId)
            ;
        var req = {
            url: url.get(),
            method: 'GET',
        };
        let result = await RawApiCall.apiCall(req);
        let ok = result.status == 200 && result.jsonOk && result.json.success == true;
        if ( !ok )
            log(LogCategory.error,"client netellerVerify error=" + result.body);

        // on error - the result.json is the error details
        // on success - the result.json.details contains what store sent us
        var nv = ok ? { page: 0,  errors: [], success: true, details: result.json.details } : result.json;
        //console.log("verify result=" + JSON.stringify(nv));
        return nv;
    }



    static async purchaseFree(state, storeProductId) {
        var siteUrl = state.siteUrl;
        var session = state.session;
        var userId = state.userId;
        var licenseId = state.licenseId;
        var email = state.email;

        log(LogCategory.clientCall,"client purchaseFree " + session + "/" + storeProductId);

        var url = new BuildUrl(siteUrl + "call")
            .add("action", "purchaseFree")
            .add("session", session)
            .add("userId", userId)
            .add("email", email)
            .add("licenseId", licenseId)
            .add("guid", storeProductId)
            ;
        var req = {
            url: url.get(),
            method: 'GET',
        };
        let result = await RawApiCall.apiCall(req);
        let ok = result.status == 200;
        if ( !ok )
            log(LogCategory.error,"client purchaseFree error=" + result.body);
        
        // on error - the result.json is the error details
        return ok ? { page: 0,  errors: [], success: true } : result.json;
    }


    static async creditCardPurchase(siteUrl, session, storeProductId, card, billing, userId, email, licenseId) {
        log(LogCategory.clientCall,"client creditCardPurchase " + session + "/" + storeProductId);

        var url = new BuildUrl(siteUrl + "call")
            .add("action", "creditCardPurchase")
            .add("session", session)
            .add("userId", userId)
            .add("email", email)
            .add("licenseId", licenseId)
            .add("guid", storeProductId)
            .add("card", card.card)
            .add("cvv", card.cvv)
            .add("expiresYear", card.expiresYear)
            .add("expiresMonth", card.expiresMonth)
            .add("name", billing.name)
            .add("address", billing.address)
            .add("country", billing.country)
            .add("city", billing.city)
            .add("zip", billing.zip)
            .add("state", billing.state)
            ;
        var req = {
            url: url.get(),
            method: 'GET',
        };
        let result = await RawApiCall.apiCall(req);
        let ok = result.status == 200;
        if ( !ok )
            log(LogCategory.error,"client creditCardPurchase error=" + result.body);
        
        // on error - the result.json is the error details
        return ok ? { page: 0,  errors: [], success: true } : result.json;
    }

    static async netellerPurchase(siteUrl, session, storeProductId, account, secureId, password, userId, email, licenseId) {
        log(LogCategory.clientCall,"client netellerPurchase " + session + "/" + storeProductId);

        var url = new BuildUrl(siteUrl + "call")
            .add("action", "netellerPurchase")
            .add("session", session)
            .add("userId", userId)
            .add("email", email)
            .add("licenseId", licenseId)
            .add("guid", storeProductId)
            .add("account", account)
            .add("secureId", secureId)
            .add("password", password)
            ;
        var req = {
            url: url.get(),
            method: 'GET',
        };
        let result = await RawApiCall.apiCall(req);
        let ok = result.status == 200 ;
        if ( !ok )
            log(LogCategory.error,"client netellerPurchase error=" + result.body);

        // on error - the result.json is the error details
        return ok ? { page: 0,  errors: [], success: true } : result.json;
    }

    static async paypalPurchase(siteUrl, session, storeProductId, userId, email, licenseId) {
        log(LogCategory.clientCall,"client paypalPurchase " + session + "/" + storeProductId);

        var url = new BuildUrl(siteUrl + "call")
            .add("action", "paypalPurchase")
            .add("session", session)
            .add("userId", userId)
            .add("email", email)
            .add("licenseId", licenseId)
            .add("guid", storeProductId)
            ;
        var req = {
            url: url.get(),
            method: 'GET',
        };
        let result = await RawApiCall.apiCall(req);
        let ok = result.status == 200 && result.json.redirectUrl !== undefined;
        if ( !ok )
            log(LogCategory.error,"client paypalPurchase error=" + result.body);

        // on error - the result.json is the error details
        return ok ? { page: 0,  errors: [], success: true, redirectUrl: result.json.redirectUrl } : result.json;
    }

    static async paymentProfilePurchase(siteUrl, session, storeProductId, profileId, userId, email, licenseId) {
        log(LogCategory.clientCall,"client paymentProfilePurchase " + session + "/" + storeProductId);

        var url = new BuildUrl(siteUrl + "call")
            .add("action", "paymentProfilePurchase")
            .add("session", session)
            .add("userId", userId)
            .add("email", email)
            .add("licenseId", licenseId)
            .add("guid", storeProductId)
            .add("profileId", profileId)
            ;
        var req = {
            url: url.get(),
            method: 'GET',
        };
        let result = await RawApiCall.apiCall(req);
        let ok = result.status == 200;
        if ( !ok )
            log(LogCategory.error,"client paymentProfilePurchase error=" + result.body);
        // on error - the result.json is the error details
        return ok ? { page: 0,  errors: [], success: true } : result.json;
    }

    static async buyNow(state) {
        var session = state.session;
        var profile = state.preselectedBuyAction.profile;
        var userId = state.userId;
        var licenseId = state.licenseId;
        var email = state.email;

        //log(LogCategory.info,"buynow=" + JSON.stringify(state.preselectedBuyAction));

        switch (state.preselectedBuyAction.preselect) {
            case 0:
                // credit card
                return await ClientCall.creditCardPurchase(state.siteUrl, session, state.buyProductId, profile.savedCard, profile.billingAddress, userId, email, licenseId);
            case 1:
                // neteller
                return await ClientCall.netellerPurchase(state.siteUrl, session, state.buyProductId, profile.neteller.account, profile.neteller.secureId,  profile.neteller.password, userId, email, licenseId );
            case 2:
                // save profile
                return await  ClientCall.paymentProfilePurchase(state.siteUrl, session, state.buyProductId, profile.paymentProfileId, userId, email, licenseId);
            default:
                console.assert(false);
                return false;
        }
    }



    static async logError(state, err) {
        var session = state.session;
        var userId = state.userId;
        var email = state.email;
        return await ClientCall._logErrorImpl(state.siteUrl, session, err, userId, email);
    }

    static async paypal(state) {
        var userId = state.userId;
        var licenseId = state.licenseId;
        var email = state.email;
        var session = state.session;
        return await ClientCall.paypalPurchase(state.siteUrl, session, state.buyProductId, userId, email, licenseId);
    }

};



// WEBPACK FOOTER //
// ./src/api/clientCall.js